import React, { useState, useEffect, useMemo, useRef } from "react";

const LetterByLetter = ({
  phrases: phrasesProp,
  as: Tag = "div",
  className = "moving-headline",
  typingSpeed = 60,
  pauseMs = 3000,
  loop = true,
}) => {
  const defaultPhrases = useMemo(
    () => [
      "On demand transportation",
      "Truck and Driver hire",
      "Easy online booking process",
      "Proudly South African",
      "Once off trips or regular trips",
      "Software and Logistics",
      "World class customer service",
      "Artificially Intelligent Logistics",
      "The future of transportation",
      "You name it, we move it",
    ],
    []
  );

  const phrases = useMemo(() => {
    if (Array.isArray(phrasesProp) && phrasesProp.length > 0) return phrasesProp;
    return defaultPhrases;
  }, [phrasesProp, defaultPhrases]);

  // Create a stable key based on actual phrases content
  const phrasesContentKey = useMemo(() => {
    try {
      return (phrases || []).join("||");
    } catch (e) {
      return String(phrases?.length || 0);
    }
  }, [phrases]);

  // Keep a stable ref to the phrases to avoid restarts on re-renders
  const phrasesRef = useRef(phrases);
  useEffect(() => {
    phrasesRef.current = phrases;
  }, [phrasesContentKey, phrases]);

  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [charIndex, setCharIndex] = useState(0);

  // Reset animation only when phrases content really changes
  useEffect(() => {
    setCurrentPhraseIndex(0);
    setCurrentText("");
    setCharIndex(0);
  }, [phrasesContentKey]);

  useEffect(() => {
    if (!phrasesRef.current || phrasesRef.current.length === 0) return;
    const currentPhrase = phrasesRef.current[currentPhraseIndex] || "";

    if (charIndex < currentPhrase.length) {
      const typeTimer = setTimeout(() => {
        setCurrentText(currentPhrase.slice(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, typingSpeed);
      return () => clearTimeout(typeTimer);
    }

    const phrasesLength = phrasesRef.current?.length || 0;
    if (!loop && currentPhraseIndex === phrasesLength - 1) {
      return; // stop after last phrase when not looping
    }

    const pauseTimer = setTimeout(() => {
      setCurrentPhraseIndex((prevIndex) =>
        (prevIndex + 1) % (phrasesRef.current?.length || 1)
      );
      setCurrentText("");
      setCharIndex(0);
    }, pauseMs);

    return () => clearTimeout(pauseTimer);
  }, [charIndex, currentPhraseIndex, phrasesContentKey, typingSpeed, pauseMs, loop]);

  return <Tag className={className}>{currentText}</Tag>;
};

export default LetterByLetter;
